import {
  Component,
  computed,
  inject,
  input,
  InputSignal,
  Signal,
  TemplateRef,
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';

export interface ITicketFrameStyling {
  borderWidth: string;
  borderColor: string;
  backgroundColor: string;
}

@Component({
  selector: 'aw-ticket-frame',
  imports: [NgTemplateOutlet, NgClass],
  templateUrl: './ticket-frame.component.html',
})
export class TicketFrameComponent<T> {
  public readonly styling: InputSignal<ITicketFrameStyling> = input.required();
  public readonly hasHeadline: InputSignal<boolean> = input(false);
  public readonly upperTicketElement: InputSignal<TemplateRef<any>> =
    input.required();
  public readonly upperSegments: InputSignal<T[]> = input<T[]>([{} as T]);
  public readonly suffix: InputSignal<string | undefined> = input<
    string | undefined
  >();

  protected readonly corporateDesign: CorporateDesignService = inject(
    CorporateDesignService
  );

  protected readonly formattedSuffix: Signal<string> = computed(() => {
    const suffix: string | undefined = this.suffix();
    return suffix ? '-' + suffix : '';
  });
}
